import React from 'react';
import ProfileHeader from './profileHeader';
import RestaurantHeader from './restaurantHeader';
const NormalRestaurantHead = ({
  nameId,
  name,
  imageUrl,
  location,
  serviceableText,
  loggedIn,
  setDrawer,
  setShowChangeLanguage,
  restaurantRating,
  restaurantAddress = '',
  cuisine = [],
}) => {
  return (
    <>
      <ProfileHeader
        nameId={nameId}
        setDrawer={setDrawer}
        setShowChangeLanguage={setShowChangeLanguage}
        imageUrl={imageUrl}
        restaurantRating={restaurantRating}
        restaurantAddress={restaurantAddress}
        cuisine={cuisine}
      />
      <RestaurantHeader
        name={name}
        location={location}
        serviceableText={serviceableText}
        restaurantRating={restaurantRating}
        restaurantAddress={restaurantAddress}
        cuisine={cuisine}
      />
    </>
  );
};

export default NormalRestaurantHead;
